import type { ReactNode } from "react";

type StepCardProps = {
  children: ReactNode;
  color: "primary" | "cyan";
  description: string;
  number: string;
  title: string;
};

export default function StepCard({ children, color, description, number, title }: StepCardProps) {
  const chrome = {
    primary: {
      badge: "from-primary-500 to-primary-600",
      card: "border-primary-100/50 from-primary-50 to-cyan-50",
    },
    cyan: {
      badge: "from-cyan-500 to-cyan-600",
      card: "border-cyan-100/50 from-cyan-50 to-sky-50",
    },
  }[color];

  return (
    <div className={`overflow-hidden rounded-2xl border bg-gradient-to-br p-8 shadow-sm ${chrome.card}`}>
      <div
        className={`mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br text-lg font-bold text-white shadow-lg ${chrome.badge}`}
      >
        {number}
      </div>
      <h3 className="mb-4 text-xl font-bold text-gray-900">{title}</h3>
      <p className="mb-6 text-gray-600">{description}</p>
      {children}
    </div>
  );
}
